import './reviews-slider';
document.querySelectorAll('.catalog-detail__info-tab').forEach((btn, i) => {
    btn.addEventListener('click', () => switchTab(i));
});

function switchTab(i) {
    document.querySelectorAll('.catalog-detail__info-tab').forEach((b, j) => {
        b.classList.toggle('active', i === j);
    });
    document.querySelectorAll('.catalog-detail__info-tab-panel').forEach((p, j) => {
        p.classList.toggle('active', i === j);
    });
}
